import useClassNames from '@medflex/hooks/useClassNames';
import isPrimaryClickEvent from '@medflex/utils/isPrimaryClickEvent';
import PropTypes from 'prop-types';
import React from 'react';
import ActionSheetContext from './ActionSheetContext';

const Item = ({ className, onClick, children, disabled }) => {
  const { isVisible, setIsVisible } = React.useContext(ActionSheetContext);
  const cn = useClassNames(
    () => [
      'border-b',
      'border-slate-200',
      'text-blue-500',
      'bg-white',
      'first:rounded-t-lg',
      'last:rounded-b-lg',
      'last:border-0',
      'hover:bg-slate-50',
      'select-none',
      className,
    ],
    [className],
  );

  return (
    <li data-component="ActionSheetItem" className={cn}>
      <button
        type="button"
        className="h-full w-full py-5 px-6 flex justify-start items-center focus:outline-none"
        onClick={event => {
          event.stopPropagation();
          if (isPrimaryClickEvent(event)) {
            onClick(event);
            if (!event.defaultPrevented) setIsVisible(!isVisible);
          }
        }}
        disabled={disabled}
      >
        {children}
      </button>
    </li>
  );
};

Item.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

Item.defaultProps = {
  onClick: () => {},
  disabled: false,
};

export default Item;
